import React, { useEffect, useMemo, useState } from 'react';
import Customselectgrowth from './Customselectgrowth';
import styles from '../GrowthTrackingTab.module.css';
import useHttp from '../../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';

import Multicustomselectgrowth from './Multicustomselectgrowth';
import RouteSelectGrowth from './Routesgrowth';

import { Truck, Route } from 'lucide-react';
function Filter_MS_Growth(props) {

    
    const [tableData, setTableData] = useState([])
    const [vinNo, setVinNumber] = useState([])
      const [regNo, setRegNumber] = useState([])
      const [selectedField, setSelectedField] = useState("VIN_NUM")
    const [lowPerforming, setLowPerforming] = useState(false)
    
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const { filterdata, setGloablfilter } = props
    

    // const clearFilter = () => {
    //     setRegNumber([])
    //     setVinNumber([])
    //     setSearchStr("")
    //     setLowPerforming(false)
    //     submit()
    //     setClearFilter(!clearFilters)
    // }

    // const updateFilter = (arr, index) => {
    //     setVinNumber(arr) 
       
        
    // }
   

    // const updateFilterForREGNo = (arr, index) => {
    //     setRegNumber(arr)
    // }
//    useEffect(() => {
//   setVinNumber([]);
//   setRegNumber([]);

//   setGloablfilter(prev => ({
//     ...prev,
//     VIN_NUM: [],
//     REG_NUM: []
//   }));
// }, [filterdata.CITY, filterdata.DEPO]);

// const handleVinChange = (selectedOptions) => {
//   setVinNumber(selectedOptions);
//   setGloablfilter(prev => ({
//     ...prev,
//     VIN_NUM: selectedOptions.map(item => item.value)
//   }));
// };

// const handleRegChange = (selectedOptions) => {
//   setRegNumber(selectedOptions);
//   setGloablfilter(prev => ({
//     ...prev,
//     REG_NUM: selectedOptions.map(item => item.value)
//   }));
// };

// Update globalFilter when REG No changes
// const updateFilterForREGNo = (arr) => {
//   setRegNumber(arr);
//   setGloablfilter(prev => ({
//     ...prev,
//     REG_NUM: arr.map(item => item.value)
//   }));
// };
useEffect(() => {
  setVinNumber([]);
  setRegNumber([]);
  setGloablfilter(prev => ({
    ...prev,
    VIN_NUM: [],
    REG_NUM: []
  }));
}, [filterdata.CITY, filterdata.DEPO]);

// On VIN selection
const handleVinChange = (selectedOptions) => {
  setVinNumber(selectedOptions);
  setGloablfilter(prev => ({
    ...prev,
    VIN_NUM: selectedOptions.map(item => item.value),
    REG_NUM: []  // Important: clear REG_NUM when VIN is active
  }));
};

// On REG selection
const handleRegChange = (selectedOptions) => {
  setRegNumber(selectedOptions);
  setGloablfilter(prev => ({
    ...prev,
    REG_NUM: selectedOptions.map(item => item.value),
    VIN_NUM: []  // Important: clear VIN_NUM when REG is active
  }));
};
    // const submit = (vinNo = [], regNo = [], str = "") => {

    //     let filterObj = {
    //         searchStr,
    //         ...filterData,
    //         CITY: filterData?.CITY?.length ? filterData?.CITY?.map(item => item?.value) : [],
    //         DEPO: filterData?.DEPO?.length ? filterData?.DEPO?.map(item => item?.value) : [],
    //         VIN_NUM: selectedField === "VIN_NUM" ? vinNo.map(item => item?.value) : [],
    //         REG_NUM: selectedField === "REG_NUM" ? regNo.map(item => item?.value) : []
    //     }
    //     // console.log("Route API filter payload 👉", filterObj);

    //     //         fetchData({
    //     //             url: API_URL_MAIN + `growth_tracking/route`,
    //     //             body: {
    //     //                 filterdata: {
    //     //                     ...filterObj,
    //     //                 }
    //     //             }
    //     //         },
    //     //            (res) => {
    //     //       const options = res?.data?.map(item => ({
    //     //         label: item?.route_name,  // adjust based on your API’s actual response field
    //     //         value: item?.route_name,
    //     //       })) || [];
    //     //       setRoutes(options);
    //     //     }
    //     //   );
    // };
    return (
        <>
            {/* <div className="container-fluid px-4">
                <div className="row mb-4">
                    <div className="col-12">
                        <div className={`card ${styles.vehicleSelection} p-3`}>
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <div className="d-flex align-items-center">
                                        <Truck className={`${styles.vehicleIcon} me-2`} />
                                        <span className="fw-medium">Vehicle Selection</span>
                                    </div>
                                </div>

                                <div className="col md-2 ">
                                    <select className={`form-select  ${styles.selectCustom}`} value={selectedField} onChange={(e) => setSelectedField(e.target.value)}>
                                        <option value="VIN_NUM">VIN No.</option>
                                        <option value="REG_NUM">Reg. No.</option>
                                    </select>
                                </div>
                                <div className={`col-md-3 ${styles.selectCustom} `}>
                                    {
                                        selectedField == "VIN_NUM" ?
                                            <Multicustomselectgrowth apiEnd="get_all_vin_num"  filterdata={filterdata} onChange={handleVinChange} />
                                            :
                                            <Multicustomselectgrowth apiEnd="get_all_reg_num"  filterdata={filterdata} onChange={handleRegChange}  />
                                    }
                                </div>
                               <RouteSelectGrowth
  filterdata={filterdata}
  onChange={(selectedRouteValues) => {
    setGloablfilter((prev) => ({
      ...prev,
      ROUTE: selectedRouteValues
    }));
  }}

/>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="container-fluid px-4">
  <div className="row mb-4">
    <div className="col-12">
      <div className={`card ${styles.vehicleSelection} p-3`}>
        <div className="row align-items-center g-3">
          {/* Vehicle Selection Label */}
          <div className="col-md-auto">
            <div className="d-flex align-items-center">
              <Truck className={`${styles.vehicleIcon} me-2`} />
              <span className="fw-medium">Vehicle Selection</span>
            </div>
          </div>

          {/* VIN / REG Toggle Dropdown */}
          <div className="col-md-2">
            <select
              className={`form-select ${styles.selectCustom}`}
              value={selectedField}
              onChange={(e) => setSelectedField(e.target.value)}
            >
              <option value="VIN_NUM">VIN No.</option>
              <option value="REG_NUM">Reg. No.</option>
            </select>
          </div>

          {/* VIN / REG Multi Select */}
          <div className="col-md-3">
            {selectedField === "VIN_NUM" ? (
              <Multicustomselectgrowth
                apiEnd="get_all_vin_num"
                filterdata={filterdata}
                onChange={handleVinChange}
              />
            ) : (
              <Multicustomselectgrowth
                apiEnd="get_all_reg_num"
                filterdata={filterdata}
                onChange={handleRegChange}
              />
            )}
          </div>
          

        </div>
      </div>
    </div>
  </div>
</div>

        </>)
}

export default Filter_MS_Growth;
